<template lang="pug">
  div
    div(class="info-header")
      | {{$t('select_country2')}}
    el-form-item(:label='$t("countryofstudy")',
      :prop="fromConsideration ? 'country.name' : 'titles.country.name'")
      el-select.countries.hideSMup(v-model='title.country.name' ,  @change="countrySelected",
        :placeholder="$t('country')", filterable)
        el-option(v-for="country in countries", :key="country.id", :label="country.name",
          :value="country.id")
          | {{country.name.length > 30 ? country.name.substring(0, 28) + '...' : country.name}}
        el-option(:label="this.$t('other_option')", value='other')
      el-select.countries.hideSMdown(v-model='title.country.name' ,  @change="countrySelected",
        :placeholder="$t('country')", filterable)
        el-option(v-for="country in countries", :key="country.id", :label="country.name",
          :value="country.id")
        el-option(:label="this.$t('other_option')", value='other')
      div.hideSMup
        | {{title.country.name && title.country.name.length > 30 ? title.country.name : ''}}
    el-tooltip(placement='right')
      div(slot='content')
        | {{ $t("hint_other_country") }}
      i.el-icon-question
    el-form-item(:label="this.$t('other_country')",
      :prop="fromConsideration ? 'country.countryInserted' : 'titles.country.countryInserted'",
      v-show="title.country.name === 'other'")
      el-input.big(:placeholder="$t('fill_in_country')",
        v-model='title.country.countryInserted',
        @change="countryInsertedChanged",
        @input="title.country.countryInserted = title.country.countryInserted.toUpperCase()")
    div
    el-form-item(:label="$t('university')", v-loading="gettingUniversities",
      :prop="fromConsideration ? 'university.name' : 'titles.university.name'")
      el-select.big.hideSMup(v-model='title.university.name' , @change="universitySelected",
        :placeholder="$t('universities')", :disabled="disableUniversity", filterable)
        el-option(v-for="university in universities", :key="university.id",
          :label="university.name", :value="university.id")
          | {{university.name.length > 30 ? university.name.substring(0, 28) + '...' : university.name}}
        el-option(:label="this.$t('other_option')", value='other', key="other")
      el-select.big.hideSMdown(v-model='title.university.name' , @change="universitySelected",
        :placeholder="$t('universities')", :disabled="disableUniversity", filterable)
        el-option(v-for="university in universities", :key="university.id",
          :label="university.name", :value="university.id")
        el-option(:label="this.$t('other_option')", value='other', key="other")
      div
        | {{title.university.name && title.university.name.length > 30 ? title.university.name : ''}}
    el-tooltip(placement='right')
      div(slot='content')
        span {{ $t("hint_other_university") }}
      i.el-icon-question
    el-form-item(:label="$t('new_university')"
      :prop="fromConsideration ? 'university.universityInserted' : 'titles.university.universityInserted'",
      v-show="title.university.name === 'other'")
      el-input.big(type="text", :placeholder="$t('fill_in_uni')",
        v-model='title.university.universityInserted',
        @change="universityInsertedChanged",
        @input="title.university.universityInserted = title.university.universityInserted.toUpperCase()")
    el-form-item(:label="$t('titleofstudy')",
      :prop="fromConsideration ? 'certificationTitle' : 'titles.certificationTitle'")
      el-input.biggest(v-model='title.certificationTitle', @change="fieldChanged",
        @input="title.certificationTitle = title.certificationTitle.toUpperCase()")
    el-tooltip(placement='right')
      div(slot='content')
        | {{ $t("hint_title") }}
      i.el-icon-question
    //- div {{title.certificationTitle}}
    div
      el-form-item(:label="$t('ects')"
        :prop="fromConsideration ? 'credits' : 'titles.credits'")
        el-input(v-model.number='title.credits' inputmode="numeric" @change="fieldChanged")
      el-tooltip(placement='right')
        div(slot='content')
          | {{ $t("hint_credits") }}
        i.el-icon-question
    div
      el-form-item(:label="$t('enroll_date')"
        :prop="fromConsideration ? 'dateOfRegistration' : 'titles.dateOfRegistration'")
        el-date-picker(v-model="title.dateOfRegistration", type="date",
          :placeholder="$t('select_date')",
          format="dd-MM-yyyy", value-format="dd-MM-yyyy",  @change="fieldChanged")
      el-tooltip(placement='right')
        div(slot='content')
          | {{ $t("hint_reg_date")}}
        i.el-icon-question
      el-form-item(:label="$t('grad_date')"
        :prop="fromConsideration ? 'dateOfGraduation' : 'titles.dateOfGraduation'")
        el-date-picker(v-model="title.dateOfGraduation", type="date",
          :placeholder="$t('select_date')",
          format="dd-MM-yyyy", value-format="dd-MM-yyyy",  @change="fieldChanged")
      el-tooltip(placement='right')
        div(slot='content')
          span {{ $t("hint_grad_date") }}
        i.el-icon-question
    div
      el-form-item(:label="$t('duration')"
        :prop="fromConsideration ? 'durationOfStudies' : 'titles.durationOfStudies'")
        el-select(v-model='title.durationOfStudies' , :placeholder="$t('years')",
        @change="fieldChanged")
          el-option(label='1', value='1')
          el-option(label='2', value='2')
          el-option(label='3', value='3')
          el-option(label='4', value='4')
          el-option(label='5', value='5')
          el-option(label='6', value='6')
      el-tooltip(placement='right')
        div(slot='content')
          span {{ $t("hint_duration") }}
        i.el-icon-question
    div
      el-form-item(:label='$t("study_madein")')
        el-switch(v-model="title.studiesInMoreUniversities", :active-text="$t('several_universities')",
          :inactive-text="$t('one_university')" @change='studiesInMoreUniversitiesChanged')
      el-tooltip(placement='right')
        div(slot='content')
          | {{ $t("hint_more_unis") }}
        i.el-icon-question
    div(v-show='title.studiesInMoreUniversities')
      el-form-item(label=' ')
        span {{$t("hint_more_unis2")}}
      div(
        v-for="(additionalUni, index) in additionalUniversities"
        :key="`additional-uni-${index}`"
        class="additional-university-inline-row"
      )
        el-button(
          @click="deleteUniversity(index)"
          size="mini"
          type="danger"
          plain="plain"
          v-show='!applicationFinalSaved'
          class="additional-university-inline-row__delete"
        )
          span {{$t("delete_university")}}
        span(class="additional-university-inline-row__label")
          | {{$t("university")}}
        el-input.additional-university-inline-row__university(
          type="text"
          v-model="additionalUni.university"
          @change="additionalUniversitiesChanged"
          @input="additionalUni.university = additionalUni.university.toUpperCase()"
        )
        span(class="additional-university-inline-row__label")
          | {{$t("credits")}}
        el-input.additional-university-inline-row__credits(
          inputmode="numeric"
          v-model.number="additionalUni.credits"
          @change="additionalUniversitiesChanged"
          @blur="markAdditionalCreditsTouched(index)"
        )
        span(
          v-if="visibleCreditsErrors[index]"
          class="additional-university-inline-row__error"
        )
          | {{ visibleCreditsErrors[index] }}
      el-form-item(label=' ')
        el-button(@click="addUniversity" size="mini" type="primary" plain="plain")
          span {{$t("add_university")}}
</template>

<script>
import axios from 'axios'
import config from '../../config.js'
import sharedMethods from './sharedMethods.js'

export default {
  mixins: [sharedMethods],
  props: [
    'title',
    'countries',
    'applicationFinalSaved',
    'fromConsideration',
    'formValidation',
  ],
  mounted() {
    if (this.title.country.name != null && !this.applicationFinalSaved) {
      this.countryChoiceId = this.title.country.id
      axios
        .get(
          `${config.BASE_URL}/countries/${this.title.country.id}/universities`
        )
        .then(response => {
          this.universities = response.data.data
          this.disableUniversity = false
        })
        .catch(err => {
          this.backendErrorNotify(err)
        })
    }
    this.emitAdditionalCreditsValidation()
  },
  data() {
    return {
      additionalUniversities: this.title.additionalUniversities,
      gettingUniversities: false,
      countryChoiceId: '',
      disableUniversity: this.title.country.name === null,
      universities: [],
      touchedAdditionalCredits: [],
    }
  },
  computed: {
    // Returns an array of error messages (or null) for each additional university credits field.
    // A credits value is valid if it is a number between 0 and 1000 (inclusive).
    creditsErrors() {
      if (!this.title.studiesInMoreUniversities) {
        return []
      }
      return this.additionalUniversities.map(additionalUni => {
        const val = additionalUni.credits
        if (val === '' || val === null || val === undefined) {
          return this.$t('ectsInsertMsg')
        }
        const num = Number(val)
        if (isNaN(num) || num < 0 || num > 1000) {
          return this.$t('ectsInsertMsg')
        }
        return null
      })
    },
    visibleCreditsErrors() {
      if (!this.title.studiesInMoreUniversities) {
        return []
      }
      return this.creditsErrors.map((error, index) => {
        if (!error) {
          return null
        }
        return this.formValidation || this.touchedAdditionalCredits[index]
          ? error
          : null
      })
    },
    // True if any additional university has an invalid credits value.
    hasInvalidCredits() {
      return this.creditsErrors.some(err => err !== null)
    },
  },
  methods: {
    markAdditionalCreditsTouched(index) {
      this.$set(this.touchedAdditionalCredits, index, true)
    },
    universityInsertedChanged() {
      this.initializeColFacDep()
      this.colleges = []
      this.faculties = []
      this.departments = []
      this.collegeFaculties = []
      this.colFacDepartments = []
      this.$emit('titleDetailsChanged', this.title)
    },
    countryInsertedChanged() {
      this.$emit('titleDetailsChanged', this.title)
    },
    emitAdditionalCreditsValidation() {
      this.$emit('additionalCreditsValid', !this.hasInvalidCredits)
    },
    additionalUniversitiesChanged() {
      this.title.additionalUniversities = this.additionalUniversities
      this.emitAdditionalCreditsValidation()
      this.$emit('titleDetailsChanged', this.title)
    },
    addUniversity() {
      this.additionalUniversities.push({
        university: '',
        credits: '',
      })
      this.touchedAdditionalCredits.push(false)
      this.title.additionalUniversities = this.additionalUniversities
      this.emitAdditionalCreditsValidation()
      this.$emit('titleDetailsChanged', this.title)
    },
    deleteUniversity(index) {
      this.additionalUniversities.splice(index, 1)
      this.touchedAdditionalCredits.splice(index, 1)
      if (this.additionalUniversities.length === 0) {
        this.title.studiesInMoreUniversities = false
      }
      this.title.additionalUniversities = this.additionalUniversities
      this.emitAdditionalCreditsValidation()
      this.$emit('titleDetailsChanged', this.title)
    },
    initializeColFacDep() {
      // this.title.faculty = {id: null, name: 'other', facultyInserted: 'ΔΕΝ ΕΧΕΙ ΟΡΙΣΘΕΙ'}
      // this.title.department = {id: null, name: 'other', departmentInserted: 'ΔΕΝ ΕΧΕΙ ΟΡΙΣΘΕΙ'}
      // this.title.college = {id: null, name: 'other', collegeInserted: 'ΔΕΝ ΕΧΕΙ ΟΡΙΣΘΕΙ'}
      this.$emit('titleDetailsChanged', this.title)
    },
    studiesInMoreUniversitiesChanged() {
      this.additionalUniversities = [{ university: null, credits: null }]
      this.title.additionalUniversities = [{ university: null, credits: null }]
      this.touchedAdditionalCredits = [false]
      this.emitAdditionalCreditsValidation()
      this.$emit('titleDetailsChanged', this.title)
    },
    countrySelected(country) {
      this.title.university = { id: null, name: null, universityInserted: '' }
      this.initializeColFacDep()
      if (country !== 'other') {
        this.title.country.countryInserted = ''
        this.title.country.name = this.countries.find(
          countr => countr.id === country
        ).name
        this.title.country.id = country
        this.countryChoiceId = country
        this.gettingUniversities = true
        this.$emit('titleDetailsChanged', this.title)
        // Todo: /universities are called twice in 3 places???
        axios
          .get(`${config.BASE_URL}/countries/${country}/universities`)
          .then(response => {
            this.universities = response.data.data
            this.disableUniversity = false
            this.gettingUniversities = false
          })
          .catch(err => {
            this.backendErrorNotify(err)
            this.disableUniversity = false
            this.gettingUniversities = false
            this.universities = []
            this.$notify.warning({
              title: this.$t('warning'),
              message: this.$t('no_unis_found'),
              offset: 100,
            })
          })
      } else {
        this.disableUniversity = false
        this.gettingUniversities = false
        this.universities = []
        this.title.country.id = null
      }
    },
    universitySelected(university) {
      this.initializeColFacDep()
      this.title.university.universityInserted = ''
      if (university !== 'other') {
        this.title.university.name = this.universities.find(
          uni => uni.id === university
        ).name
        this.title.university.id = university
        this.$emit('titleDetailsChanged', this.title)
      } else {
        this.title.university.id = null
      }
    },
    fieldChanged(el) {
      this.$emit('titleDetailsChanged', this.title)
    },
  },
  watch: {
    title: {
      handler: function(newVal, oldVal) {
        if (
          newVal.country.name !== oldVal.country.name &&
          newVal.country.name != null
        ) {
          this.countryChoiceId = newVal.country.id
          axios
            .get(
              `${config.BASE_URL}/countries/${newVal.country.id}/universities`
            )
            .then(response => {
              this.universities = response.data.data
              this.disableUniversity = false
            })
            .catch(err => {
              this.backendErrorNotify(err)
            })
        }
        this.additionalUniversities = newVal.additionalUniversities
        this.touchedAdditionalCredits = this.additionalUniversities.map(
          (item, index) => this.touchedAdditionalCredits[index] || false
        )
        this.emitAdditionalCreditsValidation()
        // this.collegeOrFaculty = this.title.collegeOrFaculty === null ||
        // this.title.collegeOrFaculty === undefined
        //   ? null
        //   : (this.title.collegeOrFaculty ? 'college' : 'faculty')
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';

.info-header {
  border-radius: 5px 20px;
  border: 2px solid #7fa3bb;
  padding: 5px;
  margin: 5px;
  width: 380px;
}

.el-input {
  width: 240px;
}
.el-autocomplete {
  width: 440px;
}
.my-autocomplete {
  li {
    line-height: normal;
    padding: 3px;

    .value {
      text-overflow: clip;
      font-size: 9px;
      overflow: hidden;
      color: #6d728b;
      white-space: normal;
    }
    .link {
      text-overflow: clip;
      font-size: 10px;
      color: #33408a;
      white-space: normal;
    }
  }
}
// @media only screen and (min-width: $screen-sm-min) {
//   .maxSteps {
//     display: none;
//   }
// }
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 190px;
}
.el-input {
  &.big {
    width: 440px;
  }
  &.biggest {
    width: 540px;
  }
}
.el-textarea {
  &.biggest {
    width: 540px;
  }
}
.el-select {
  &.big {
    width: 440px;
  }
  &.biggest {
    width: 1100px;
  }
  &.countries {
    width: 440px;
  }
}
.hideSMup {
  display: none;
}
.hideSMdown {
  display: block;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 180px;
}
.el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #1b91de;
}

.additional-university-inline-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.additional-university-inline-row__delete {
  flex: 0 0 auto;
}

.additional-university-inline-row__label {
  flex: 0 0 auto;
}

.additional-university-inline-row__university {
  width: 240px;
}

.additional-university-inline-row__credits {
  width: 120px;
}

.additional-university-inline-row__error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1.2;
  white-space: nowrap;
}

@media only screen and (max-width: $screen-sm-min) {
  .hideSMup {
    display: block;
  }
  .hideSMdown {
    display: none;
  }
  .el-autocomplete {
    width: 240px;
  }
  .el-input {
    &.big {
      width: 240px;
    }
    &.biggest {
      width: 240px;
    }
  }
  .el-select {
    &.countries {
      width: 240px;
    }
    &.big {
      width: 240px;
    }
    &.biggest {
      width: 240px;
    }
  }
  .additional-university-inline-row {
    align-items: flex-start;
  }
  .additional-university-inline-row__university {
    width: 240px;
  }
  .additional-university-inline-row__credits {
    width: 120px;
  }
  .additional-university-inline-row__error {
    white-space: normal;
  }
}
</style>
